module.exports = __webpack_public_path__ + "img/image0.906e27fc.jpg";